/**
 * @generated SignedSource<<70d3c97edfb8d0f36efe43745da511ad>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentType } from "relay-runtime";
declare export opaque type AgentConnectedDialog_organization$fragmentType: FragmentType;
export type AgentConnectedDialog_organization$data = {|
  +agents?: ?{|
    +count: number,
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +name: string,
      |},
    |}>,
  |},
  +slug: string,
  +$fragmentType: AgentConnectedDialog_organization$fragmentType,
|};
export type AgentConnectedDialog_organization$key = {
  +$data?: AgentConnectedDialog_organization$data,
  +$fragmentSpreads: AgentConnectedDialog_organization$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isMounted"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AgentConnectedDialog_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "condition": "isMounted",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "last",
              "value": 1
            }
          ],
          "concreteType": "AgentConnection",
          "kind": "LinkedField",
          "name": "agents",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "count",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AgentEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Agent",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "agents(last:1)"
        }
      ]
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node/*: any*/).hash = "27694a433c3d7a43475aeb21bf94af2d";

module.exports = ((node/*: any*/)/*: Fragment<
  AgentConnectedDialog_organization$fragmentType,
  AgentConnectedDialog_organization$data,
>*/);
